import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  Chip,
  Grid,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import './RescheduleOrder.scss';
import delivery from '../../../../../app/assets/images/delivery/delivery.jpg';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import nofiles from '../../../../../src/app/assets/gifs/nofiles.gif';
import search from '../../../../../app/assets/gifs/search.gif';
import InfiniteScroll from '../../../../../common/components/infinitescroll/InfiniteScroll';
import { useRef } from 'react';
import { capitalizeFirstLetter } from '../../../../../utils/commonFunctions';

const RescheduleOrder = ({
  orders,
  setOrders,
  currentTrip,
  orderType,
  handleAssign,
  tripID,
  onScroll,
  ref,
  key
}: any) => {
  const inputRef = useRef<any>();
  return (
    <div
      onScroll={() => {
        const { scrollTop, scrollHeight, clientHeight } = inputRef.current;
        const data = { scrollTop, scrollHeight, clientHeight };
        onScroll(data);
      }}
      ref={inputRef}
      style={{ height: '400px', overflowY: 'auto', scrollbarWidth: 'none' }}
      className='reschedule-orders'
    >
      {(orderType === 'NOT_DELIVERED' || orderType === 'RESCHEDULED') &&
        orders?.length > 0 && (
          <Stack className='reschedule-panel'>
            <Box className='reschedule-label'>
              <Typography className='reschedule-header'>{`Reschedule All Orders for Trip ID: ${
                tripID ?? '-'
              }`}</Typography>
              <Checkbox
                checked={
                  orders?.length > 0
                    ? orders?.every((item: any) => item?.selected)
                    : false
                }
                onClick={(e: any) => {
                  setOrders((prev: any) => {
                    const allOrders = prev?.map((item: any) => ({
                      ...item,
                      selected: e?.target?.checked
                    }));
                    return allOrders;
                  });
                }}
                className='reschedule-check'
              />
            </Box>
            <CustomButton
              category='Assign'
              className='assign'
              icon='ic:baseline-assignment'
              onClick={handleAssign}
            />
          </Stack>
        )}

      <Grid container gap={2.5}>
        {orders?.length > 0 ? (
          orders?.map((item: any, index: number) => (
            <Grid item lg={2.8} md={4} sm={12} xs={12}>
              <Card className='order-cards'>
                <CardMedia
                  component='img'
                  height='120'
                  image={delivery}
                  alt='green iguana'
                />
                {['NOT_DELIVERED', 'RESCHEDULED'].includes(orderType) && (
                  <Checkbox
                    icon={<RadioButtonUncheckedIcon />}
                    checked={item?.selected}
                    checkedIcon={<CheckCircleIcon />}
                    onClick={(e: any) => {
                      setOrders((prev: any) => {
                        let newOrders = [...prev];
                        prev[index].selected = e.target.checked;
                        return newOrders;
                      });
                    }}
                    sx={{ position: 'absolute', top: 0, right: 0 }}
                  ></Checkbox>
                )}

                <CardContent className='order-content'>
                  <Typography gutterBottom component='div' className='order-header'>
                    {`Order ID : ${item?.assignedOrderId}`}
                  </Typography>
                  <Tooltip title={item?.customerName}>
                    <Typography
                      noWrap
                      className='customer-name'
                    >{`Customer Name : ${capitalizeFirstLetter(
                      item?.customerName
                    )}`}</Typography>
                  </Tooltip>
                  <Typography className='order-status'>
                    Trip ID : <Chip label={item?.tripId} size='small'></Chip>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Box className='no-orders'>
            <Box component='img' src={search}></Box>
            <Typography className='noorders-text'>No Orders Found</Typography>
          </Box>
        )}
      </Grid>
    </div>
  );
};

export default RescheduleOrder;
